import { User } from './models/user';

export interface AuthState {
  user: User;
  impersonatedClientId?: string;
  isLoaded: boolean;
  signedInClientId?: string;
  isSignedInClientValid: boolean;
}

export const authFeatureKey = 'auth';
